import PubSub from 'pubsub-js';
import './content_index';
import './content_about';
import './content_strength1';
import './content_strength2';
import './content_strength3';
import './content_strength4';
import './content_news';
import './content_insight';
import './content_team';
import './content_contact';

const SCENES = ['index', 'about', 'strength1', 'strength2', 'strength3', 'strength4', 'news', 'team', 'insight', 'contact',];
const $html = $('html');
const $contents = $('.contents');

let scene = 0;

const showLead = (target) => {
    $(target).addClass('-show');
}

const hideLead = (target) => {
    $(target).removeClass('-show');
}

const intersection = () => {
    const targets = document.querySelectorAll(`.content__lead, .content__title`);

    const options = {
      root: null,
      rootMargin: '0px 0px',
      threshold: 0.5,
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
            const showTarget = $(entry.target);
            showLead(showTarget);
        }
      });
    }, options);

    targets.forEach(target => {
      observer.observe(target);
    });
};

PubSub.subscribe('init', () => {
    const device = $html.data('device');
    if (device !== 'mobile') {
        const showTarget = $(`.content:eq(${scene})`, $contents);
        showTarget.addClass('-current');
    
        showLead($('.content__lead', showTarget));
      } else {
        intersection();
    }
});

PubSub.subscribe('top.updateScene', (_msg, data) => {
    const hideTarget = $(`.content:eq(${scene})`, $contents);
    const showTarget = $(`.content:eq(${data})`, $contents);
    hideTarget.removeClass('-current');
    showTarget.addClass('-current');

    hideLead($('.content__lead', hideTarget));
    showLead($('.content__lead', showTarget));
    PubSub.publish(`top.${SCENES[scene]}.hide`);
    PubSub.publish(`top.${SCENES[data]}.show`);

    sessionStorage.setItem('scene', SCENES[data]);

    scene = data;
});
